import script from "./SummonMobFavs.vue?vue&type=script&setup=true&lang=js"
export * from "./SummonMobFavs.vue?vue&type=script&setup=true&lang=js"

import "./SummonMobFavs.vue?vue&type=style&index=0&id=49f92c73&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49f92c73"]])

export default __exports__